import { render, staticRenderFns } from "./keywordModal.vue?vue&type=template&id=5762a354&scoped=true"
import script from "./keywordModal.vue?vue&type=script&lang=js"
export * from "./keywordModal.vue?vue&type=script&lang=js"
import style0 from "./keywordModal.vue?vue&type=style&index=0&id=5762a354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762a354",
  null
  
)

export default component.exports